/** Cuentas oficiales. Las usan el topbar, el drawer y el footer. */
export const SOCIAL_LINKS = [
  { name: "Facebook", href: "https://www.facebook.com/tocumenaero" },
  { name: "Instagram", href: "https://www.instagram.com/tocumenaero" },
  { name: "X", href: "https://x.com/tocumenaero" },
  {
    name: "YouTube",
    href: "https://www.youtube.com/@aeropuertodetocumenpanama",
  },
];
